/* eslint-disable no-console */

import { configureStore } from '@reduxjs/toolkit';
import {
    useDispatch as useAppDispatch,
    useSelector as useAppSelector,
} from 'react-redux';
import { apiSlice } from '../api/apiSlice';
import { authApiSlice } from '../api/authApiSlice';
import { feedSlice } from '../api/feedSlice';
import { appUpdateVersion } from '../utils/config';
import auth2Reducer from './slices/authSlice';
import list2Reducer from './slices/listSlice';
import localReducer from './slices/localSlice';
import feedReducer from './slices/feedSlice';

// Save to local storage (persist)
const saveToLocalStorage = (state) => {
    try {
        const stringState = JSON.stringify(state);
        localStorage.setItem(`${appUpdateVersion}`, stringState);
    } catch (err) {
        console.log(err);
    }
};

// Load from local storage
const loadFromLocalStorage = () => {
    try {
        const stringState = localStorage.getItem(`${appUpdateVersion}`);
        if (stringState === null) return undefined;
        return JSON.parse(stringState);
    } catch (err) {
        console.log(err);
        return undefined;
    }
};

const persistedStorage = loadFromLocalStorage();

const store = configureStore({
    preloadedState: persistedStorage,
    reducer: {
        auth: auth2Reducer,
        list2: list2Reducer,
        local: localReducer,
        feed: feedReducer,
        [apiSlice.reducerPath]: apiSlice.reducer,
        [authApiSlice.reducerPath]: authApiSlice.reducer,
        [feedSlice.reducerPath]: feedSlice.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).concat(
            apiSlice.middleware,
            authApiSlice.middleware,
            feedSlice.middleware
        ),
});

//Sync to local storage everytime store changes
store.subscribe(() => {
    saveToLocalStorage(store.getState());
});

const { dispatch } = store;
const useSelector = useAppSelector;
const useDispatch = () => useAppDispatch();

export { store, dispatch, useSelector, useDispatch };
